import React from 'react'

function AI_program_details() {
  return (
    <div>
    {/* -------------------Mobile View------------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>The Marvels of Artificial Intelligence!</h1>
                    <p className='py-2'>Embark on a transformative journey! Enrol now in our Artificial Intelligence courses and pave the way for a brighter future filled with innovation and endless possibilities.</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Get started on an exciting new adventure in AI with our all-encompassing training program. This course will teach you all you need to know about deep learning, as well as the fundamentals of Python and data analysis with Pandas. Explore artificial neural networks, convolutional neural networks, and gain hands-on experience with real applications. Improve your knowledge of AI setup, model training, and picture processing. Complete your education with exciting capstone projects that give you a comprehensive understanding of this revolutionary field.</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Artificial Intelligence</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>


    {/* ---------------------Desktop view----------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'> The Marvels of Artificial Intelligence!</h1>
                    <p className='py-4'>Embark on a transformative journey! Enrol now in our Artificial Intelligence courses and pave the way for a brighter future filled with innovation and endless possibilities.</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Get started on an exciting new adventure in AI with our all-encompassing training program. This course will teach you all you need to know about deep learning, as well as the fundamentals of Python and data analysis with Pandas. Explore artificial neural networks, convolutional neural networks, and gain hands-on experience with real applications. Improve your knowledge of AI setup, model training, and picture processing. Complete your education with exciting capstone projects that give you a comprehensive understanding of this revolutionary field.</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Artificial Intelligence</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default AI_program_details
